var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { avgParticipantsFromRaw, emptyMeetingLoadRawCounts } from '@workalizer/shared';
import { diffComparisonValueFormat } from '@workalizer/shared/types';
import { buildMetricTotal, randomInt, sharePercent } from '@workalizer/shared/utils';
export { sharePercent };
export var generateMeetingsBucketMockRaw = function () {
    var meetingCount = randomInt(10, 40);
    var avgParticipants = randomInt(20, 90) / 110;
    var participantsSum = Math.round(meetingCount * avgParticipants);
    var durationSeconds = randomInt(5, 25) * 3600 + randomInt(0, 59) * 60;
    var manHoursSeconds = durationSeconds * Math.max(1, Math.round(avgParticipants));
    return {
        meetingCount: meetingCount,
        durationSeconds: durationSeconds,
        manHoursSeconds: manHoursSeconds,
        participantsSum: participantsSum
    };
};
export var buildMeetingsBucketDemoRow = function (key, curr, prev, currShare, prevShare, includeTeamMetrics) { return (__assign({ key: key, shareOfMeetings: buildMetricTotal(prevShare, currShare), meetingCount: buildMetricTotal(prev.meetingCount, curr.meetingCount), durationSeconds: buildMetricTotal(prev.durationSeconds, curr.durationSeconds, diffComparisonValueFormat.durationSeconds) }, (includeTeamMetrics && {
    manHoursSeconds: buildMetricTotal(prev.manHoursSeconds, curr.manHoursSeconds, diffComparisonValueFormat.durationSeconds),
    avgParticipants: buildMetricTotal(avgParticipantsFromRaw(prev), avgParticipantsFromRaw(curr))
}))); };
export var emptyMeetingLoadBucket = function () { return emptyMeetingLoadRawCounts(); };
